import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=11c85b94&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=11c85b94&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c85b94",
  null
  
)

export default component.exports